import request from "./clientsApi";
import { API_ROUTES } from "../config/baseURL";

export const apiGetConsecutivos = async () => {
  const res = await request(API_ROUTES.getcons(""), { method: "GET" });
  return res.json();
};

export const getConsById = async (id) => {
  const res = await request(API_ROUTES.getConsById(id), { method: "GET" });
  return res.json();
};

export const apiSaveCons = async (payload) => {
  const isUpdate = !!payload.id;
  const res = await request(API_ROUTES.saveCons, {
    method: isUpdate ? "PUT" : "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
};
